import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  TableSortLabel,
} from '@material-ui/core';
import { UserBet } from '../../models/UserBet';
import { RootState } from '../../models/RootState';
import './ExchOpenBets.scss';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { getCurrencyTypeFromToken } from '../../store';

type StoreProps = {
  openBets: UserBet[];
};

const getDisplayName = (runnerName: string) => {
  let name =
    runnerName.split(':').length > 1
      ? runnerName.split(':')[1]
      : runnerName.split(':')[0];
  if (name.toLowerCase().includes('crudeoil')) return 'CRUDE OIL';
  else if (name.toLowerCase().includes('gold')) return 'GOLD';
  else if (name.toLowerCase().includes('silver')) return 'SILVER';
  else if (name.toLowerCase().includes('banknifty')) return 'BANK NIFTY';
  return name;
};
type Order = 'asc' | 'desc';

const ExchOpenBets: React.FC<StoreProps> = (props) => {
  const { openBets } = props;

  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [sortOrder, setSortOrder] = React.useState<Order>('asc');
  const [sortBy, setSortBy] = React.useState<string>('time');

  const getMatchedBets = (bets: UserBet[]) => {
    const matchedBets = bets.filter((bet: UserBet) => {
      return !bet.unmatched;
    });

    return matchedBets;
  };

  const getBetDisplayName = (bet: UserBet) => {
    switch (bet.marketType) {
      // TODO: remove binary
      case 'FANCY':
      case 'BINARY':
        return (
          (bet.marketType === 'BINARY'
            ? getDisplayName(bet.outcomeDesc)
            : bet.marketName) +
          ' @ ' +
          Number(bet.oddValue * 100 - 100).toFixed(0)
        );
      case 'BOOKMAKER':
        return `${
          bet.marketName.toLowerCase().includes('toss') ? 'Toss' : 'BM'
        } - ${bet.outcomeDesc}`;
      case 'MATCH_ODDS':
        if (bet.marketName === 'Completed Match') {
          return 'Completed Match - ' + bet.outcomeDesc;
        } else if (bet.marketName === 'Tied Match') {
          return 'Tied Match - ' + bet.outcomeDesc;
        } else {
          return 'MO - ' + bet.outcomeDesc;
        }
      default:
        return bet.marketName + ' - ' + bet.outcomeDesc;
    }
  };

  const getBetOddValue = (bet: UserBet) => {
    return bet.marketType === 'FANCY' || bet.marketType === 'BINARY'
      ? Number(bet.sessionRuns).toFixed(0) +
        '/' +
        Number(bet.oddValue * 100 - 100).toFixed(0)
      : bet.marketType === 'BOOKMAKER'
      ? Number(bet.oddValue * 100 - 100).toFixed(2)
      : Number(bet.oddValue.toFixed(2))
  };

  const getBetStakeAmount = (bet: UserBet) =>
    Number(bet.stakeAmount / cFactor).toFixed(2);

  return (
    <div className="open-bets-ctn">
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Market</TableCell>
              <TableCell align="left">
                <TableSortLabel
                  active={sortBy === 'oddValue'}
                  direction={sortOrder}
                  onClick={() => {
                    setSortBy('oddValue');
                    setSortOrder((prevState) =>
                      prevState === 'asc' ? 'desc' : 'asc'
                    );
                  }}
                >
                  Odds
                </TableSortLabel>
              </TableCell>
              <TableCell align="left">
                <TableSortLabel
                  active={sortBy === 'stakeAmount'}
                  direction={sortOrder}
                  onClick={() => {
                    setSortBy('stakeAmount');
                    setSortOrder((prevState) =>
                      prevState === 'asc' ? 'desc' : 'asc'
                    );
                  }}
                >
                  Stake
                </TableSortLabel>
              </TableCell>
              <TableCell className="stake-cell" align="left">
                P&L
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {getMatchedBets(openBets)?.length > 0 ? (
              <>
                {getMatchedBets(openBets)
                  .sort((a, b) =>
                    sortBy === 'stakeAmount'
                      ? sortOrder === 'asc'
                        ? Number(a.stakeAmount) - Number(b.stakeAmount)
                        : Number(b.stakeAmount) - Number(a.stakeAmount)
                      : sortBy === 'time'
                      ? b.betPlacedTime - a.betPlacedTime
                      : sortOrder === 'asc'
                      ? Number(a.oddValue) - Number(b.oddValue)
                      : Number(b.oddValue) - Number(a.oddValue)
                  )
                  .map((bet, idx) => (
                    <>
                      {!bet.unmatched ? (
                        <TableRow
                          className={
                            bet.betType === "BACK" ? 'back-bet ' : 'lay-bet '
                          }
                          key={'row' + idx}
                        >
                          <TableCell component="th">
                            <div className="market-name-col">
                              {getBetDisplayName(bet)}
                            </div>
                          </TableCell>
                          <TableCell key={'odds-cell-row' + idx} align="left">
                            {getBetOddValue(bet)}
                          </TableCell>
                          <TableCell key={'stake-cell-row' + idx} align="left">
                            {getBetStakeAmount(bet)}
                          </TableCell>
                          <TableCell key={'stake-cell-row' + idx} align="left">
                            <div
                              className={bet.betType == "BACK" ? 'profit' : 'loss'}
                            >
                              {bet.betType == "BACK" ? '+' : '-'}

                              {(
                                Number(
                                  Number(
                                    (bet.oddValue - 1) * bet.stakeAmount
                                  ).toFixed(2)
                                ) / cFactor
                              ).toFixed(2)}
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : null}
                    </>
                  ))}
              </>
            ) : (
              <TableRow className="no-data-row">
                <TableCell colSpan={5} className="no-data-cell" align="center">
                  No Open Bets Found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetslip.openBets,
  };
};

export default connect(mapStateToProps, null)(ExchOpenBets);
